var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePurchase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25873_172558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 2.1L1.3125 5.46054C1.31242 5.56504 1.35371 5.66531 1.42734 5.73945L8.1457 12.4578C8.29353 12.6049 8.4936 12.6875 8.70215 12.6875C8.9107 12.6875 9.11077 12.6049 9.2586 12.4578L12.4578 9.25859C12.6049 9.11076 12.6875 8.9107 12.6875 8.70215C12.6875 8.4936 12.6049 8.29353 12.4578 8.1457L5.74219 1.43008C5.66805 1.35644 5.56777 1.31515 5.46328 1.31523H2.1C1.99667 1.31473 1.89427 1.33466 1.79867 1.37389C1.70308 1.41311 1.61619 1.47085 1.543 1.54379C1.46981 1.61673 1.41176 1.70342 1.3722 1.79888C1.33265 1.89433 1.31236 1.99667 1.3125 2.1Z",
    stroke: "#50C878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 3.5C4.375 3.67306 4.32368 3.84223 4.22754 3.98612C4.13139 4.13002 3.99473 4.24217 3.83485 4.30839C3.67496 4.37462 3.49903 4.39195 3.3293 4.35819C3.15956 4.32442 3.00365 4.24109 2.88128 4.11872C2.75891 3.99635 2.67558 3.84044 2.64181 3.6707C2.60805 3.50097 2.62538 3.32504 2.69161 3.16515C2.75783 3.00527 2.86998 2.86861 3.01388 2.77246C3.15777 2.67632 3.32694 2.625 3.5 2.625C3.73207 2.625 3.95462 2.71719 4.11872 2.88128C4.28281 3.04538 4.375 3.26793 4.375 3.5Z",
    fill: "#50C878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25873_172558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePurchase);
export default __webpack_public_path__ + "static/media/ActivePurchase.5d85728ee0484b7e65cb39b685ea6450.svg";
export { ForwardRef as ReactComponent };